/*
 * L.TileLayer is used for standard xyz-numbered tile layers.
 */
/* tslint:disable */
declare const google: any;
(L as any).Google = L.Layer.extend({
  includes: L.Evented,

  options: {
    minZoom: 0,
    maxZoom: 18,
    tileSize: 256,
    subdomains: 'abc',
    errorTileUrl: '',
    attribution: '',
    opacity: 1,
    zoomAnimation: true,
    continuousWorld: false,
    noWrap: false,
  },

  // Possible types: SATELLITE, ROADMAP, HYBRID
  initialize: function (type: any, options: any) {
    L.Util.setOptions(this, options);

    this._type = google.maps.MapTypeId[type || 'SATELLITE'];
  },

  onAdd: function (map: any, insertAtTheBottom: any) {
    this._map = map;

    this._insertAtTheBottom = insertAtTheBottom;

    // create a container div for tiles
    this._initContainer();
    this._initMapObject();

    // set up events
    map.on('viewreset', this._resetCallback, this);

    this._limitedUpdate = L.Util.throttle(this._update, 2, this);
    map.on('move', this._update, this);
    //map.on('moveend', this._update, this);

    this._reset();
    this._update();
  },

  onRemove: function (map: any) {
    this._map._container.removeChild(this._container);
    //this._container = null;

    this._map.off('viewreset', this._resetCallback, this);

    this._map.off('move', this._update, this);
    //this._map.off('moveend', this._update, this);
  },

  getAttribution: function () {
    return this.options.attribution;
  },

  setOpacity: function (opacity: any) {
    this.options.opacity = opacity;
    if (opacity < 1) {
      L.DomUtil.setOpacity(this._container, opacity);
    }
  },

  _initContainer: function () {
    const tilePane = this._map._container,
      first = tilePane.firstChild;

    if (!this._container) {
      this._container = L.DomUtil.create('div', 'leaflet-google-layer leaflet-top leaflet-left');
      this._container.style.zIndex = 0;
      this._container.id = '_GMapContainer';
    }

    if (true) {
      tilePane.insertBefore(this._container, first);

      this.setOpacity(this.options.opacity);
      const size = this._map.getSize();
      this._container.style.width = size.x + 'px';
      this._container.style.height = size.y + 'px';
    }
    //
    //
    // this._map.on('zoomend', function(e) {
    //   debugger
    //   this._container.classList = this._container.classList;
    // });
  },

  _initMapObject: function () {
    this._google_center = new google.maps.LatLng(0, 0);
    const map = new google.maps.Map(this._container, {
      center: this._google_center,
      zoom: 0,
      tilt: 0,
      mapTypeId: this._type,
      disableDefaultUI: true,
      keyboardShortcuts: false,
      draggable: false,
      disableDoubleClickZoom: true,
      scrollwheel: false,
      streetViewControl: false,
      styles: [
        { featureType: 'poi', stylers: [{ visibility: 'off' }] },
        { featureType: 'road.highway', elementType: 'labels', stylers: [{ visibility: 'off' }] }, //turns off highway labels
        { featureType: 'road.arterial', elementType: 'labels', stylers: [{ visibility: 'off' }] }, //turns off arterial roads labels
        { featureType: 'road.local', elementType: 'labels', stylers: [{ visibility: 'off' }] }, //turns off local roads labels
      ],
    });

    map.backgroundColor = '#ff0000';
    this._google = map;
  },

  _resetCallback: function (e: any) {
    this._reset(e.hard);
  },

  _reset: function (clearOldContainer: any) {
    this._initContainer();
  },

  _update: function () {
    // TODO remettre
    this._resize();

    const bounds = this._map.getBounds();
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const center = this._map.getCenter();
    const _center = new google.maps.LatLng(center.lat, center.lng);

    this._google.setCenter(_center);
    this._google.setZoom(this._map.getZoom());
    //this._google.fitBounds(google_bounds);
  },

  _resize: function () {
    const size = this._map.getSize();
    if (this._container.style.width == size.x && this._container.style.height == size.y) return;
    this._container.style.width = size.x + 'px';
    this._container.style.height = size.y + 'px';
    google.maps.event.trigger(this._google, 'resize');
  },
});
/* tslint:enable*/
